import { initCopyLoginLink } from "./initCopyLoginLink";

export const copyLoginLink = {
  initCopyLoginLink
};
